
























































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { namespace, Mutation } from 'vuex-class';
import PageTitle from '@/components/common/PageTitle.vue';
import BasicInformation from '@/components/product/BasicInformation.vue';
import DeliveryInformation from '@/components/product/DeliveryInformation.vue';
import ImagesInformation from '@/components/product/ImagesInformation.vue';
import NaverPayGuide from '@/components/product/NaverPayGuide.vue';
import AgreementStatusHelp from '@/components/product/AgreementStatusHelp.vue';
import ImmediateDiscountGuide from '@/components/product/ImmediateDiscountGuide.vue';
import SalesInformation from '@/components/product/SalesInformation.vue';
import AdditionalInputItems from './AdditionalInputItems.vue';
import { Admin, Partner } from '@/types';
import {
  Mds,
  StandardCategory,
  StandardCategoriesTree,
  DisplayCategoriesView,
  DisplayCategoriesTree,
  Brand,
  SalesUnit,
  PlaceOrigin,
  GetDeliveryTemplate,
  DeliveryCompany,
  Mall,
  PostProductsRequest,
  GetMallsDeliveryPartnersByMallNo,
  GetProduct,
  PutProductByNoRequest,
  OptionMapping,
  ProductsGuide,
  GetProductsImmutableFieldsRequest,
} from 'supporter';
import { toI18n } from '@/utils/commonUtils';
import { getToday, addMonth, addDay } from '@/utils/dateUtils';

const mallModule = namespace('mall');
const adminModule = namespace('admin');
const termsModule = namespace('terms');
const deliveryModule = namespace('delivery');

@Component({
  components: {
    PageTitle,
    BasicInformation,
    DeliveryInformation,
    ImagesInformation,
    SalesInformation,
    NaverPayGuide,
    ImmediateDiscountGuide,
    AgreementStatusHelp,
    AdditionalInputItems,
  },
})
export default class ProductAdd extends Vue {
  @Mutation('SET_DIMMEDAREASWITCH') private setDimmedAreaSwitch!: (flag: boolean) => void;
  @termsModule.Mutation('SET_NCPLAYERISSHOW') public setPopIsShow!: (isExist: boolean) => void;
  @termsModule.Mutation('SET_NCPLAYERISEXIST') public setPopIsExist!: (isExist: boolean) => void;
  @termsModule.Mutation('SET_POPINFO') public setPopInfo!: (popInfo: {}) => void;
  @mallModule.State('malls') private stateMalls!: Mall[];
  @adminModule.Getter('admin') private stateAdmin!: Admin;
  @deliveryModule.Getter('deliveryCompanies') deliveryCompanyTypes!: DeliveryCompany[];

  // 임시저장 버튼
  private temporarySaveApplyStatusTypes = ['REGISTRATION_READY'];
  // 승인요청 버튼
  private approvalApplyStatusTypes = ['REGISTRATION_READY', 'APPROVAL_READY', 'APPROVAL_REJECTION'];
  private beforFinishedApplyStatusTypes = [
    'REGISTRATION_READY',
    'APPROVAL_READY',
    'APPROVAL_REJECTION',
    'SALE_AGREEMENT_READY',
    'SALE_AGREEMENT_REJECTION',
  ];
  private afterFinishedApplyStatusTypes = ['FINISHED', 'AFTER_APPROVAL_READY', 'AFTER_APPROVAL_REJECTION'];
  private displayGuideFlag = false;
  private displayImmediateDiscountHelpFlag = false;
  private isOption = false;
  private isMapping = false;
  private wmsUsed = false;
  private immutableFields: any[] = [];
  private selectRefund = false;
  private firstInitDataChange = false;
  private selectMallNo = false;
  private modifiable = false;
  private isUpdated = false;
  private productNameEn = {
    checkYn: false,
  };
  private buyInfo = {
    minBuyYn: 'N',
    maxBuyYn: 'N',
    maxPurchaseType: 'TIME',
  };
  private deliveryDate = {
    deliveryDateYn: 'N',
    periodYn: 'N',
    daysAfterPurchaseYn: 'N',
  };
  private deliveryCustomerInfo = {
    useYn: 'N',
  };
  private productGuide: ProductsGuide = { type: 'DELEGATION_BY_LIQUOR' };
  private initProductGuide: ProductsGuide = { type: 'DELEGATION_BY_LIQUOR' };
  private product: any = {
    keywords: '',
    promotionTextInfo: {
      startYmd: getToday(),
      endYmd: addMonth(new Date(), 3),
      periodYn: false,
      text: '',
    },
    contentHeader: '',
    purchasePrice: 0,
    deliveryDueDate: {
      daysOfTheWeek: ['MON', 'TUE', 'WED', 'THU', 'FRI'],
      period: {
        endDate: addMonth(new Date(), 3),
        startDate: getToday(),
      },
      daysAfterPurchase: 1,
    },
    productName: '',
    optionType: 'DEFAULT',
    mallNo: 0,
    groupType: 'DELIVERY',
    classType: 'DEFAULT',
    partnerNo: 0,
    saleMethodType: 'CONSIGNMENT',
    adminNo: 0,
    categoryNo: 0,
    displayCategoryNos: [],
    urlDirectDisplayYn: false,
    searchengineDisplayYn: true,
    platformDisplayInfo: {
      displayYn: 'Y',
      pcYn: true,
      mobileWebYn: true,
      mobileYn: true,
    },
    memberGradeDisplayInfo: {
      check: 'NONE',
      info: [],
    },
    memberGroupDisplayInfo: {
      check: 'NONE',
      info: [],
    },

    productNameEn: '',
    promotionTextUseYn: false,

    brandName: '',
    minorPurchaseYn: 'Y',
    nonmemberPurchaseYn: false,
    paymentMeansControlYn: 'N',
    extraJson: {
      naverPayLimitYn: false,
      manufactureName: '',
      productModelName: '',
      serialNumber: '',
    },
    extraInfo: '',
    paymentMeans: [],
    cartInfo: {
      offStartYmd: getToday(),
      useYn: 'Y',
      offPeriodYn: false,
      offEndYmd: addMonth(new Date(), 3),
    },

    reservationUseYn: 'N',
    reservationInfoModel: {
      deliveryYmdt: addDay(new Date(), 1),
      startYmdt: getToday(),
      endYmdt: getToday(),
      stockCnt: '',
    },
    salePeriodInfo: {
      startYmdt: getToday(),
      periodType: 'REGULAR',
      endYmdt: '2030-12-31',
    },
    commissionInfo: {
      rate: '',
      type: 'PRODUCT',
    },
    salePrice: '',
    discountPrice: 0,
    maxImmediateDiscountWon: 0,
    unitPriceYn: false,
    unitPriceInfo: {
      price: '',
      name: '',
      type: '',
    },
    addOptionImageYn: 'N',
    immediateDiscountInfo: {
      unitType: 'AMOUNT',
      startYmdt: getToday(),
      amount: 0,
      endYmdt: addMonth(new Date(), 3, '-'),
      periodYn: false,
    },
    accumulationSaveYn: 'N',
    accumulationRate: 0,
    partnerChargeAmt: '',
    accumulationUseYn: 'Y',
    promotionInfo: {
      couponYn: true,
      promotionYn: 'Y',
      additionalDiscountYn: true,
      freeGiftYn: 'Y',
    },
    productStockCnt: '',
    useRestockNotiYn: 'N',
    minBuyCnt: '',
    maxBuyCountInfo: {
      maxBuyTimeCnt: '',
      maxBuyDays: '',
      maxBuyPeriodCnt: '',
      maxBuyPersonCnt: '',
    },
    comparingPriceSiteInfo: {
      check: 'ANY',
      info: null,
    },
    dutyInfo: null,
    certificationInfo: {
      data: [],
      type: 'TARGET',
    },
    placeOriginInfo: {
      placeOriginsYn: false,
      placeOrigin: '',
      placeOriginSeq: 0,
    },
    manufactureYmdt: '',
    expirationYmdt: '',
    valueAddedTaxType: 'DUTY',
    productManagementCd: '',
    refundableInfo: {
      nonRefundableInfo: ['CANCEL', 'EXCHANGE', 'RETURN'],
      refundableYn: 'Y',
    },
    refundableYn: 'Y',
    hsCode: '',
    extraManagementCd: '',
    stickerNos: [],
    stickerInfos: [],
    mallProductListImage: '',
    mallProductImages: [],
    content: '',
    contentFooter: '',
    deliveryYn: 'Y',
    deliveryCustomerInfo: '',
    shippingAreaType: 'PARTNER_SHIPPING_AREA',
    deliveryCombinationYn: false,
    deliveryInternationalYn: false,
    deliveryTemplateNo: 0,
    customPropertyValues: [],
    options: [],
    tempSave: false,
    shippingAreaPartnerNo: 0,
    eanCode: '',
    customerDemands: [],
    saleStatusType: 'PRE_APPROVAL_STATUS',
    applyStatusType: 'REGISTRATION_READY',
  };
  private partner: Partner | null = null;
  private useNaverPay: boolean = false;
  private categoryCommissionUseYn: boolean = false;
  private admins: Mds[] = [];
  private admin = {
    adminName: '',
  };
  private standardCategories: StandardCategory[] = [];
  private standardCategoriesTree: StandardCategoriesTree[] = [];
  private displayCategories: DisplayCategoriesView[] = [];
  private displayCategoriesTree: DisplayCategoriesTree[] = [];
  private displayCategoryNames: any[] = [];
  private brands: Brand[] = [];
  private brand = {
    selfInput: false,
    brandNo: 0,
    brandName: '',
  };
  private salesUnits: SalesUnit[] = [];
  private placeOrigins: PlaceOrigin[] = [];
  private deliveryTemplates: GetDeliveryTemplate[] = [];
  private accumulationUseYnDisabled = true;
  private diliveryPartner: GetMallsDeliveryPartnersByMallNo | null = null;
  private error: { [key: string]: any } = {};
  private contentUse = {
    contentHeaderUse: 'N',
    contentFooterUse: 'N',
  };
  private html = {
    header: '',
    content: '',
    footer: '',
  };
  private selectedPlaceOrigin: any = {
    selectedPlaceOriginDepth2: '',
    selectedPlaceOriginDepth1: '',
    selectedOriginCountry: '',
  };
  private disableArea = {
    partner: false,
    admin: false,
    standardCategory: false,
    displayCategory: false,
    brand: false,
    deliveryTemplate: false,
  };
  private useMallAuth = false;
  private partnerDeliveryTemplates: GetDeliveryTemplate[] = [];
  private scrolled = false;
  private agreementStatusHelp = false;

  get standardCategory(): any {
    if (this.product.categoryNo) {
      const standardCategory = this.standardCategories.find(item => item.depth4CategoryNo === this.product.categoryNo);
      standardCategory.commissionRate = this.getCommissionRate(this.product.categoryNo);
      return standardCategory;
    } else {
      return { categoryFullName: '', requiresAdultCertification: false, commissionRate: '' };
    }
  }
  /**
   *완료   : .complete
    진행중 : .active
    비활성 : .disabled
   */
  getClass(applyStatusType: string, rejectionApplyStatusType: string) {
    if (this.beforFinishedApplyStatusTypes.includes(applyStatusType)) {
      const productIndex = this.beforFinishedApplyStatusTypes.indexOf(this.product.applyStatusType);
      const currentTabIndex = this.beforFinishedApplyStatusTypes.indexOf(
        rejectionApplyStatusType ? rejectionApplyStatusType : applyStatusType,
      );
      if (productIndex > currentTabIndex) {
        return ' complete';
      }
      if (currentTabIndex > productIndex) {
        return ' disabled';
      }
      if (currentTabIndex === productIndex) {
        return ' active';
      }
    }
    if (this.afterFinishedApplyStatusTypes.includes(applyStatusType)) {
      const productIndex = this.afterFinishedApplyStatusTypes.indexOf(this.product.applyStatusType);
      const currentTabIndex = this.afterFinishedApplyStatusTypes.indexOf(
        rejectionApplyStatusType ? rejectionApplyStatusType : applyStatusType,
      );
      if (productIndex > currentTabIndex) {
        return ' complete';
      }
      if (currentTabIndex > productIndex) {
        return ' disabled';
      }
      if (currentTabIndex === productIndex) {
        return ' active';
      }
    }
    return '';
  }
  getCommissionRate(categoryNo: number) {
    let commissionRate = 0;
    this.standardCategoriesTree.forEach(tree => {
      tree.child.forEach(childTree => {
        childTree.child.forEach(childChildTree => {
          if (childChildTree.categoryNo === categoryNo) {
            commissionRate = childChildTree.commissionRate;
          }
        });
      });
    });
    return commissionRate;
  }
  get roundingRule() {
    if (this.product.mallNo) {
      const mall = this.stateMalls.find(item => item.mallNo === this.product.mallNo) as Mall;
      return mall ? mall.roundingRule : null;
    }
    return null;
  }
  mounted() {
    window.addEventListener('scroll', this.scrollHandler);
    setTimeout((): void => {
      if (this.$route.name === 'EditProduct') {
        $(document).attr('title', this.$t('PRODUCT_ADD_UPDATE') as string);
      }
      if (this.$route.name === 'CopyProduct') {
        $(document).attr('title', this.$t('PRODUCT_ADD_COPY') as string);
      }
    }, 1000);
  }
  updated() {
    this.isUpdated = true;
  }
  scrollHandler() {
    this.scrolled = Boolean(window.pageYOffset) || document.documentElement.scrollTop > 0;
  }
  fetchDataWithMallChanged() {
    this.disableArea.standardCategory = true;
    this.disableArea.displayCategory = true;
    const mallProductConfigRequest = {
      params: {
        mallNo: this.product.mallNo, // 상품 설정 조회
      },
    };

    return Promise.all([
      this.$api.getContractsConfigurations(mallProductConfigRequest).then(res => {
        if (!res.data.promotionAgreed && this.$route.name === 'AddProduct') {
          this.product.promotionInfo.promotionYn = 'N';
        }
        this.partner.commissionRate = res.data.commissionRate;
        if (this.partner.commissionRate && this.$route.name !== 'EditProduct' && this.$route.name !== 'CopyProduct') {
          this.product.commissionInfo.type = 'PARTNER';
          this.product.commissionInfo.rate = this.partner.commissionRate;
        }
        this.product.accumulationRate = res.data.accumulationRateOfMall;
        this.useNaverPay = !!res.data.usableEasyPaymentMethods.find(pay => pay.provider === 'NAVER');
      }),
      this.$api.getProductsConfiguration(mallProductConfigRequest).then(ret => {
        if (ret && ret.data) {
          this.categoryCommissionUseYn = ret.data.categoryCommissionUsed;
          this.wmsUsed = ret.data.wmsUsed;
        }
      }),
      this.$api
        .getMemberJoinConfig({
          params: {
            mallNo: this.product.mallNo, // 상품 설정 조회
          },
        })
        .then(res => {
          this.useMallAuth = res.data.memberAuthenticationType !== 'NOT_USED';
        }),
      this.$api
        .getAdminsServiceMerchandisers({
          params: {
            mallNo: this.product.mallNo,
          },
        })
        .then(ret => {
          this.admins = ret.data;
        }),

      Promise.all([
        this.$api
          .getStandardCategories({
            params: {
              mallNo: this.product.mallNo,
            },
          })
          .then(ret => {
            this.standardCategories = ret.data;
          }),
        this.$api
          .getStandardCategoriesTree({
            params: {
              mallNo: this.product.mallNo,
            },
          })
          .then(ret => {
            this.standardCategoriesTree = ret.data.tree;
          }),
      ]).then(() => {
        this.disableArea.standardCategory = false;
      }),

      Promise.all([
        this.$api
          .getDisplayCategoriesViews({
            params: {
              mallNo: this.product.mallNo,
            },
          })
          .then(ret => {
            this.displayCategories = ret.data;
          }),
        this.$api
          .getDisplayCategoriesTree({
            params: {
              mallNo: this.product.mallNo,
            },
          })
          .then(ret => {
            this.displayCategoriesTree = ret.data;
          }),
      ]).then(() => {
        this.disableArea.displayCategory = false;
      }),
    ]);
  }
  created() {
    this.setPopIsExist(true);
    this.setDimmedAreaSwitch(true);
    this.$store.commit('SET_DIMMEDAREA', false);
    // partner 固定
    this.product.partnerNo = this.stateAdmin.partnerNo;
    this.$api
      .getPartnersInfoByNo({ pathParams: { partnerNo: String(this.product.partnerNo) } })
      .then(res => {
        this.partner = res.data;
      })
      .then(() => {
        this.getPartnerDeliveryTemplates(this.product.partnerNo);
        this.$api.getProductEnumsSalesUnit().then(ret => {
          this.salesUnits = ret.data;
          if (ret.data.length > 0) {
            if (this.product.unitPriceInfo) {
              this.product.unitPriceInfo.type = this.salesUnits[0].name;
            } else {
              this.product.unitPriceInfo = { type: this.salesUnits[0].name };
            }
          }
        });
        this.$api.getPlaceOrigins().then(ret => {
          this.placeOrigins = ret.data;
        });

        if (this.$route.name === 'EditProduct' || this.$route.name === 'CopyProduct') {
          const syncStockYn = this.$route.query.syncStockYn;

          const usage =
            this.$route.name === 'EditProduct' ? 'UPDATE' : syncStockYn === 'Y' ? 'COPY_WITH_STOCK' : 'COPY';

          const params: GetProductsImmutableFieldsRequest['params'] = {
            productNo: this.$route.params.productNo,
            usage: usage,
          };
          this.$api.getProductsImmutableFields({ params }).then(res => {
            this.immutableFields = res.data.immutableFields;
          });
          this.$api.getProductByNo({ params: { mallProductNo: Number(this.$route.params.productNo) } }).then(ret => {
            const product = ret.data;

            // @NOTE 기등록 상품의 사은품 설정 마이그레이션 처리
            product.promotionInfo.freeGiftYn = product.promotionInfo?.freeGiftYn === 'Y' ? 'Y' : 'N';

            if (syncStockYn === 'Y') {
              product.synced = true;
            }
            this.setProduct(product);
          });
        }

        const { isOption, isMapping } = this.$route.query;
        if (isOption) {
          this.isOption = true;
        }
        if (isMapping) {
          this.isMapping = true;
          this.product.optionType = 'MAPPING';
        }
        if (this.stateMalls.length === 1) {
          this.product.mallNo = this.stateMalls[0].mallNo;
          this.changedMall();
        }
      });
  }
  /**
   * 몰변경
   */
  changedMall(callback?: any) {
    if (this.product.mallNo) {
      this.selectMallNo = false;
      this.fetchDataWithMallChanged().then(() => {
        if (callback) {
          callback();
        }
      });
      if (typeof callback !== 'function') {
        this.initParamsWithMallChanged();
      }
    }
  }
  /**
   * 몰변경시 파라미터 초기화
   */
  private initParamsWithMallChanged() {
    // * 옵션정보 초기화
    this.product.options = [];
    this.product.customerDemands = [];
    // *  판매수수료 초기화
    this.product.commissionInfo = {
      rate: 0,
      type: 'PRODUCT',
    };
    // * 파트너 정보 초기화
    // * 전시카테고리 정보 초기화
    this.product.displayCategoryNos = [];
    // * 배송비템플릿 초기화
    this.product.deliveryTemplateNo = this.deliveryTemplates.find((item: any) => item.default)?.templateNo;
    // * 담당자 정보 초기화
    this.product.adminNo = 0;
    // * 상품추가항목 초기화
    this.product.customPropertyValues = [];
    // * 스티커 정보 초기화
    this.product.stickerNos = [];
    // * 이미지, 리스트이미지 초기화, 상품상세(상중하) 초기화
    this.product.mallProductListImage = '';
    this.product.mallProductImages = [];
    this.product.contentHeader = '';
    this.product.content = '';
    this.product.contentFooter = '';
    this.brand.selfInput = false;
    this.product.brandName = '';
    this.brand.brandNo = undefined;
    this.brand.brandName = '';
    // * 몰 설정정보에 따라 판매수수료, 결제수단제어, 적립금적립, 적립금사용 영향 html에서 컨트롤
    // * 결제수단제어 항목의 네이버페이 체크박스 및 가이드 문구 노출 설정 html에서 컨트롤
  }
  /**
   * 받은 product으로 화면에서 사용하는 product 설정
   */
  setProduct(product: GetProduct) {
    if (this.$route.name === 'CopyProduct') {
      this.product.mallNo = this.$route.query.mallNo;
    } else {
      this.product.mallNo = product.mallNo;
    }

    this.isMapping = product.optionType === 'MAPPING' ? true : false;
    this.isOption = product.optionUseYn === 'Y' && product.optionType !== 'MAPPING' ? true : false;
    this.changedMall(() => {
      this.setProductChangedMallCallBack(product);
    });
  }

  getSupplyPrice(product: GetProduct) {
    if (product.commissionInfo.type === 'PURCHASE_PRICE' || product.saleMethodType === 'PURCHASE') {
      return product.purchasePrice;
    }
    const discountPrice = this.getDiscountPrice(product);
    if (product.commissionInfo.rate) {
      const fees = (discountPrice * product.commissionInfo.rate) / 100;
      const scaled = Math.pow(10, 1);
      const scaledfees = fees * scaled;
      return discountPrice - Math.round(scaledfees) / scaled;
    } else {
      return discountPrice;
    }
  }
  getDiscountPrice(product: GetProduct) {
    const isWon = product.immediateDiscountInfo.unitType === 'AMOUNT';
    let discountAmt = 0;
    if (isWon) {
      discountAmt = product.immediateDiscountInfo.amount;
    } else {
      const discountRateAmt = (product.salePrice * product.immediateDiscountInfo.amount) / 100;
      if (this.roundingRule && discountRateAmt) {
        const { roundingMode, scale } = this.roundingRule;
        const scaled = Math.pow(10, scale);
        const scaledDiscountRateAmt = discountRateAmt * scaled;
        if (roundingMode === 'DOWN') {
          discountAmt = Math.floor(scaledDiscountRateAmt) / scaled;
        } else if (roundingMode === 'UP') {
          discountAmt = Math.ceil(scaledDiscountRateAmt) / scaled;
        } else {
          // HALF_UP
          discountAmt = Math.round(scaledDiscountRateAmt) / scaled;
        }
      } else {
        discountAmt = discountRateAmt;
      }
    }
    return product.salePrice - discountAmt;
  }
  /**
   * 몰변경에 의한 데이터 조회후 조회한 데이터에 의하여 product 설정
   */
  setProductChangedMallCallBack(product: GetProduct) {
    this.modifiable = product.modifiable;
    this.firstInitDataChange = true;

    const makedProduct: any = {
      parentNo: product.parentNo,
      keywords: product.keywords.toString(),
      dutyInfo: { dutyContent: product.dutyContent },
      contentHeader: product.contentHeader,
      mallProductNo: product.mallProductNo,
      optionType: product.optionType,
      productName: product.productName,
      ...(product.classType === 'RENTAL' && {
        manufactureName: product.extraJson.manufactureName,
        productModelName: product.extraJson.productModelName,
        serialNumber: product.extraJson.serialNumber,
      }),
      deliveryYn: product.deliveryYn,
      minorPurchaseYn: product.minorPurchaseYn,
      options: product.optionType !== 'DEFAULT' ? product.options : [],
      mallProductListImage: '',
      mallProductImages: product.mallProductImages,
      commissionInfo: {
        type: product.commissionInfo.type,
        rate: product.commissionInfo.rate.toFixed(1),
      },
      brandNo: product.brandNo,
      salePeriodInfo: product.salePeriodInfo,
      shippingAreaPartnerNo: product.shippingAreaPartnerNo,
      brandName: product.brandName,
      certificationInfo: product.certificationInfo,
      accumulationUseYn: product.accumulationUseYn,
      shippingAreaType: product.shippingAreaType,
      refundableYn: product.refundableYn,
      refundableInfo: product.refundableInfo,
      immediateDiscountInfo: {
        unitType: product.immediateDiscountInfo.unitType,
        startYmdt: product.immediateDiscountInfo.startYmdt,
        amount: product.immediateDiscountInfo.amount,
        endYmdt: product.immediateDiscountInfo.endYmdt,
        periodYn: product.immediateDiscountInfo.periodYn === 'Y' ? true : false,
      },
      accumulationRate: product.accumulationRate,
      platformDisplayInfo: {
        displayYn: product.platformDisplayInfo.displayYn,
        mobileWebYn: product.platformDisplayInfo.mobileWebYn === 'Y',
        mobileYn: product.platformDisplayInfo.mobileYn === 'Y',
        pcYn: product.platformDisplayInfo.pcYn === 'Y',
      },
      cartInfo: {
        offStartYmd: product.cartInfo.offStartYmd,
        useYn: product.cartInfo.useYn,
        offPeriodYn: product.cartInfo.offPeriodYn === 'Y' ? true : false,
        offEndYmd: product.cartInfo.offEndYmd,
      },
      classType: product.classType,
      customerDemands: product.customerDemands ? product.customerDemands : [],
      displayCategoryNos: product.displayCategoryNos,
      productManagementCd: product.productManagementCd,
      searchengineDisplayYn: product.searchengineDisplayYn === 'Y' ? true : false,
      minBuyCnt: product.minBuyCnt,
      groupType: product.groupType,
      content: product.content,
      nonmemberPurchaseYn: product.nonmemberPurchaseYn === 'N' ? true : false,
      saleMethodType: product.saleMethodType,
      partnerChargeAmt: product.partnerChargeAmt,
      partnerNo: product.partnerNo,
      deliveryInternationalYn: product.deliveryInternationalYn === 'Y' ? true : false,
      eanCode: product.eanCode,
      deliveryCustomerInfo: product.deliveryCustomerInfo,
      deliveryTemplateNo: product.deliveryTemplateNo,
      addOptionImageYn: product.addOptionImageYn,
      customPropertyValues: product.customPropertyValues,
      contentFooter: product.contentFooter,
      adminNo: product.adminNo,
      salePrice: product.salePrice,
      saleSettingStatusType: product.saleSettingStatusType,
      urlDirectDisplayYn: product.urlDirectDisplayYn === 'Y' ? true : false,
      stickerNos: product.stickerInfos.map(stickerInfo => stickerInfo.stickerNo),
      stickerInfos: product.stickerInfos,
      promotionInfo: {
        couponYn: product.promotionInfo.couponYn === 'Y' ? true : false,
        promotionYn: product.promotionInfo.promotionYn,
        additionalDiscountYn: product.promotionInfo.additionalDiscountYn === 'Y' ? true : false,
        freeGiftYn: product.promotionInfo.freeGiftYn,
      },
      useRestockNotiYn: product.useRestockNotiYn,
      synced: product.synced,
      valueAddedTaxType: product.valueAddedTaxType,
      hsCode: product.hsCode,
      mallNo: this.$route.name === 'CopyProduct' ? this.$route.query.mallNo : product.mallNo,
      placeOriginInfo: {
        placeOriginsYn: false,
        placeOrigin: '',
        placeOriginSeq: 0,
      },
      relatedProductInfo: product.relatedProductInfo,
      memberGradeDisplayInfo: product.memberGradeDisplayInfo,
      memberGroupDisplayInfo: product.memberGroupDisplayInfo,
      extraManagementCd: product.extraManagementCd,
    };

    /**
     * 상품복사일경우 syncStockYn,copyStockCntYn 에 따라 productStockCnt
     * copyReviewYn설정
     */
    if (this.$route.name === 'CopyProduct') {
      const syncStockYn = this.$route.query.syncStockYn;
      const copyStockCntYn = this.$route.query.copyStockCntYn;
      const copyReviewYn = this.$route.query.copyReviewYn;
      if (syncStockYn === 'N' && copyStockCntYn === 'N') {
        makedProduct.productStockCnt = 0;
      } else {
        makedProduct.productStockCnt = product.productStockCnt;
      }

      if (copyReviewYn === 'Y') {
        makedProduct.copiesReview = true;
      } else {
        makedProduct.copiesReview = false;
      }
      makedProduct.saleStatusType = 'PRE_APPROVAL_STATUS';
      makedProduct.applyStatusType = 'REGISTRATION_READY';
    } else {
      makedProduct.productStockCnt = product.productStockCnt;
      makedProduct.saleStatusType = product.saleStatusType;
      makedProduct.applyStatusType = product.applyStatusType;
    }

    if (product.promotionTextInfo.text) {
      makedProduct.promotionTextUseYn = true;
      makedProduct.promotionTextInfo = {
        startYmd: product.promotionTextInfo.periodYn === 'Y' ? product.promotionTextInfo.startYmd : getToday(),
        endYmd: product.promotionTextInfo.periodYn === 'Y' ? product.promotionTextInfo.endYmd : addMonth(new Date(), 3),
        periodYn: product.promotionTextInfo.periodYn === 'Y',
        text: product.promotionTextInfo.text,
      };
    } else {
      makedProduct.promotionTextUseYn = false;
      makedProduct.promotionTextInfo = {
        startYmd: getToday(),
        endYmd: addMonth(new Date(), 3),
        periodYn: false,
        text: '',
      };
    }
    if (product.mallProductListImage) {
      makedProduct.mallProductListImage = product.mallProductListImage;
    }
    if (product.reservationInfo) {
      makedProduct.reservationUseYn = 'Y';
      makedProduct.reservationInfoModel = {
        deliveryYmdt: product.reservationInfo.deliveryYmdt,
        startYmdt: product.reservationInfo.startYmdt,
        endYmdt: product.reservationInfo.endYmdt,
        stockCnt: product.reservationInfo.stockCnt,
      };
    } else {
      makedProduct.reservationUseYn = 'N';
      makedProduct.reservationInfoModel = {
        deliveryYmdt: addDay(new Date(), 1),
        startYmdt: getToday(),
        endYmdt: getToday(),
        stockCnt: '',
      };
    }
    if (product.accumulationRate !== null) {
      makedProduct.accumulationSaveYn = 'Y';
    } else {
      makedProduct.accumulationSaveYn = 'N';
    }
    if (
      product.maxBuyCountInfo.maxBuyTimeCnt ||
      product.maxBuyCountInfo.maxBuyPersonCnt ||
      product.maxBuyCountInfo.maxBuyPeriodCnt ||
      product.maxBuyCountInfo.maxBuyDays
    ) {
      this.buyInfo.maxBuyYn = 'Y';
      if (product.maxBuyCountInfo.maxBuyTimeCnt) {
        this.buyInfo.maxPurchaseType = 'TIME';
        makedProduct.maxBuyCountInfo = {
          maxBuyTimeCnt: product.maxBuyCountInfo.maxBuyTimeCnt,
          maxBuyPersonCnt: '',
          maxBuyPeriodCnt: '',
          maxBuyDays: '',
        };
      } else if (product.maxBuyCountInfo.maxBuyPersonCnt) {
        this.buyInfo.maxPurchaseType = 'PERSON';
        makedProduct.maxBuyCountInfo = {
          maxBuyTimeCnt: '',
          maxBuyPersonCnt: product.maxBuyCountInfo.maxBuyPersonCnt,
          maxBuyPeriodCnt: '',
          maxBuyDays: '',
        };
      } else {
        this.buyInfo.maxPurchaseType = 'DAYS';
        makedProduct.maxBuyCountInfo = {
          maxBuyTimeCnt: '',
          maxBuyPersonCnt: '',
          maxBuyPeriodCnt: product.maxBuyCountInfo.maxBuyPeriodCnt,
          maxBuyDays: product.maxBuyCountInfo.maxBuyDays,
        };
      }
    } else {
      makedProduct.maxBuyCountInfo = {
        maxBuyTimeCnt: '',
        maxBuyPersonCnt: '',
        maxBuyPeriodCnt: '',
        maxBuyDays: '',
      };
    }
    if (product.minBuyCnt) {
      this.buyInfo.minBuyYn = 'Y';
    }
    if (product.expirationYmdt) {
      makedProduct.expirationYmdt = product.expirationYmdt;
    } else {
      makedProduct.expirationYmdt = '';
    }
    if (product.manufactureYmdt) {
      makedProduct.manufactureYmdt = product.manufactureYmdt;
    } else {
      makedProduct.manufactureYmdt = '';
    }
    if (product.unitPriceInfo) {
      makedProduct.unitPriceYn = true;
      makedProduct.unitPriceInfo = product.unitPriceInfo;
    } else {
      makedProduct.unitPriceYn = false;
      makedProduct.unitPriceInfo = {
        price: '',
        name: '',
        type: this.salesUnits[0].name,
      };
    }
    if (product.productNameEn) {
      this.productNameEn.checkYn = true;
      makedProduct.productNameEn = product.productNameEn;
    } else {
      makedProduct.productNameEn = '';
    }
    if (product.placeOriginInfo) {
      const placeOrigin = this.placeOrigins.find(
        placeOrigin => placeOrigin.originNo === product.placeOriginInfo.placeOriginSeq,
      ) as PlaceOrigin;
      if (placeOrigin) {
        this.selectedPlaceOrigin.selectedOriginCountry = placeOrigin.originCountry;
        if (placeOrigin.originCountyCode !== 'EX') {
          this.selectedPlaceOrigin.selectedPlaceOriginDepth1 = placeOrigin.depth1;
          this.selectedPlaceOrigin.selectedPlaceOriginDepth2 = placeOrigin.depth2;
        } else {
          this.selectedPlaceOrigin.selectedPlaceOriginDepth1 = product.placeOriginInfo.placeOriginSeq;
          this.selectedPlaceOrigin.selectedPlaceOriginDepth2 = '';
        }

        makedProduct.placeOriginInfo = {
          placeOriginsYn: product.placeOriginInfo.placeOriginsYn === 'Y' ? true : false,
          placeOrigin: product.placeOriginInfo.placeOrigin,
          placeOriginSeq: product.placeOriginInfo.placeOriginSeq,
        };
      }
    }

    if (makedProduct.adminNo) {
      const admin = this.admins.find(admin => admin.adminNo === makedProduct.adminNo) as Mds;
      if (admin) {
        this.admin.adminName = admin.name;
      } else {
        this.admin.adminName = '';
        makedProduct.adminNo = '';
      }
    }
    if (this.$route.query.syncStockYn !== 'Y') {
      if (makedProduct.displayCategoryNos) {
        makedProduct.displayCategoryNos = makedProduct.displayCategoryNos.filter(displayCategoryNo => {
          const finded = this.displayCategories.find(
            displayCategory => displayCategory.depth5DisplayCategoryNo === displayCategoryNo,
          ) as DisplayCategoriesView;
          if (finded) {
            this.displayCategoryNames.push({
              name: finded.fullCategoryName,
              display: finded.depth5Displayable ? 'Y' : 'N',
            });
          }
          return finded;
        });
      }
    }
    if (makedProduct.brandName) {
      this.brand.brandName = makedProduct.brandName;
      this.brand.brandNo = product.brandNo;
    }
    makedProduct.categoryNo = product.categoryNo;
    if (product.contentHeader) {
      this.contentUse.contentHeaderUse = 'Y';
      this.html.header = product.contentHeader;
    }
    if (product.content) {
      this.html.content = product.content;
    }
    if (product.contentFooter) {
      this.contentUse.contentFooterUse = 'Y';
      this.html.footer = product.contentFooter;
    }
    if (product.comparingPriceSiteInfo) {
      if (product.comparingPriceSiteInfo.check === 'ALL') {
        makedProduct.comparingPriceSiteInfo = {
          check: 'ANY',
          info: ['NAVER', 'FACEBOOK', 'DANAWA', 'ENURI', 'COOCHA', 'WONDER'],
        };
      } else {
        makedProduct.comparingPriceSiteInfo = product.comparingPriceSiteInfo;
      }
    }
    if (product.extraJson) {
      makedProduct.extraJson = product.extraJson;
      if (
        product.extraJson.naverPayLimitYn &&
        (product.extraJson.naverPayLimitYn === 'Y' || product.extraJson.naverPayLimitYn === 'true')
      ) {
        makedProduct.extraJson.naverPayLimitYn = true;
      } else {
        makedProduct.extraJson.naverPayLimitYn = false;
      }
    }
    if (product.extraInfo) {
      makedProduct.extraInfo = product.extraInfo;
    }
    makedProduct.deliveryCombinationYn = !(product.deliveryCombinationYn && product.deliveryCombinationYn === 'Y');
    if (product.deliveryDueDate) {
      this.deliveryDate.deliveryDateYn = 'Y';
      makedProduct.deliveryDueDate = {};
      makedProduct.deliveryDueDate.daysOfTheWeek = product.deliveryDueDate.daysOfTheWeek;
      if (product.deliveryDueDate.period) {
        this.deliveryDate.periodYn = 'Y';
        makedProduct.deliveryDueDate.period = product.deliveryDueDate.period;
      }
      if (product.deliveryDueDate.daysAfterPurchase) {
        this.deliveryDate.daysAfterPurchaseYn = 'Y';
        makedProduct.deliveryDueDate.daysAfterPurchase = product.deliveryDueDate.daysAfterPurchase;
      }
    } else {
      makedProduct.deliveryDueDate = {
        daysOfTheWeek: ['MON', 'TUE', 'WED', 'THU', 'FRI'],
        period: {
          endDate: addMonth(new Date(), 3),
          startDate: getToday(),
        },
        daysAfterPurchase: 1,
      };
    }
    if (product.optionType === 'MAPPING') {
      makedProduct.options = product.options.map(option => {
        let addPrice = 0;
        (option.mappings as OptionMapping[]).forEach(mapping => {
          addPrice = addPrice + mapping.mappingOptionSalePrice;
        });
        option.addPrice = addPrice;
        return option;
      });
    }
    if (product.deliveryCustomerInfo) {
      this.deliveryCustomerInfo.useYn = 'Y';
    }
    if (product.paymentMeans.includes('PAYCO_POINT')) {
      makedProduct.paymentMeansControlYn = 'PAYCO_POINT';
      makedProduct.paymentMeans = [];
    } else {
      makedProduct.paymentMeansControlYn = product.paymentMeansControlYn;
      makedProduct.paymentMeans = product.paymentMeans;
    }
    let minOptionPrice = 0;
    if (product.optionType === 'COMBINATION') {
      product.options.forEach(option => {
        if (minOptionPrice > option.addPrice) {
          minOptionPrice = option.addPrice;
        }
      });
    }

    makedProduct.maxImmediateDiscountWon = this.getMaxImmediateDiscountWon(product.salePrice, minOptionPrice);
    makedProduct.discountPrice = this.getDiscountPrice(product);
    makedProduct.purchasePrice = this.getSupplyPrice(product);

    this.product = makedProduct;
    this.productGuide = product.productGuides.length ? { ...product.productGuides[0] } : null;
    this.initProductGuide = product.productGuides.length ? { ...product.productGuides[0] } : null;

    if (this.firstInitDataChange) {
      this.$nextTick(() => {
        this.firstInitDataChange = false;
      });
    }
  }
  getMaxImmediateDiscountWon(salePrice: number, minOptionPrice: number) {
    const max = salePrice + minOptionPrice;
    return max >= 10 ? max : 0;
  }
  /**
   * 파트너 배송관련 조회
   */
  getPartnerDeliveryTemplates(partnerNo: number) {
    if (partnerNo) {
      this.$api
        .getDeliveryTemplates({
          params: {
            partnerNo: partnerNo,
          },
        })
        .then(ret => {
          if (this.product.shippingAreaType === 'PARTNER_SHIPPING_AREA') {
            this.deliveryTemplates = ret.data;
          }
          this.partnerDeliveryTemplates = ret.data;
        });
    }
  }

  @Watch('product.shippingAreaType')
  onShippingAreaTypeChanged(newVal: any) {
    if (newVal === 'MALL_SHIPPING_AREA') {
      this.$api
        .getMallsDeliveryPartnersByMallNo({
          params: {
            mallNo: this.product.mallNo,
          },
        })
        .then(ret => {
          this.product.shippingAreaPartnerNo = ret.data.partnerNo;
        })
        .then(() => {
          this.$api
            .getDeliveryTemplates({
              params: {
                partnerNo: this.product.shippingAreaPartnerNo,
              },
            })
            .then(ret => {
              this.deliveryTemplates = ret.data;
            });
        });
    } else {
      this.deliveryTemplates = this.partnerDeliveryTemplates;
      this.product.shippingAreaPartnerNo = 0;
    }
  }

  filterUnDisplayCategory(tree: DisplayCategoriesTree[]): DisplayCategoriesTree[] {
    tree = tree.filter(branch => branch.displayYn === 'Y');
    tree.map(branch => {
      if (branch.children.length) {
        branch.children = this.filterUnDisplayCategory(branch.children);
      }
      return branch;
    });
    return tree;
  }
  /**
   * 선택된 파트너 설정
   */
  private setPartner(partner: any) {
    this.partner = partner;
  }
  /**
   * 임시저장,저장,승인요청 클릭시
   */
  private submit(isSave?: string) {
    this.setDimmedAreaSwitch(false);
    if (this.product.mallNo === 0) {
      alert(this.$t('PRODUCT_ADD_ERROR'));
      $('#mallNo').focus();
      this.selectMallNo = true;
      return;
    }

    if (!this.product.refundableInfo.nonRefundableInfo.length && this.product.refundableInfo.refundableYn === 'N') {
      alert(this.$t('PRODUCT_ADD_ERROR'));
      $('#cancelNo').focus();
      this.selectRefund = true;
      return;
    }

    const param = this.getParam(isSave);
    if (this.$route.name === 'EditProduct') {
      this.put(param as PutProductByNoRequest);
    } else if (this.$route.name === 'CopyProduct') {
      this.copy(param as PostProductsRequest);
    } else {
      this.post(param as PostProductsRequest);
    }
  }

  /**
   * 상품 복사
   */
  private copy(param) {
    if (this.$route.query.syncStockYn === 'Y') {
      this.$api
        .postProductsByMallProductNo(param)
        .then((ret: any) => {
          alert(`${ret.data + this.$t('PRODUCT_ADD_SAVED')}`);
          this.goListPage();
        })
        .catch(this.handleError);
    } else {
      this.$api
        .postProducts(param)
        .then((ret: any) => {
          alert(`${ret.data + this.$t('PRODUCT_ADD_SAVED')}`);
          this.goListPage();
        })
        .catch(this.handleError);
    }
  }
  /**
   * 상품수정
   */
  private put(param: PutProductByNoRequest) {
    this.$api
      .putProductByNo(param)
      .then(ret => {
        alert(`${ret.data + this.$t('PRODUCT_ADD_UPDATE_SAVED')}`);
        this.goListPage();
      })
      .catch(this.handleError);
  }
  /**
   * 상품 등록
   */
  private post(param: PostProductsRequest) {
    this.$api
      .postProducts(param)
      .then((ret: any) => {
        alert(`${ret.data + this.$t('PRODUCT_ADD_SAVED')}`);
        this.goListPage();
      })
      .catch(this.handleError);
  }
  /**
   * 등록&수정시 파라미터 생성
   */
  private getParam(isSave?: string) {
    const { product } = this;

    const param: any = {
      data: {
        productName: product.productName,
        ...(product.classType === 'RENTAL' && {
          manufactureName: product.extraJson.manufactureName,
          productModelName: product.extraJson.productModelName,
          serialNumber: product.extraJson.serialNumber,
        }),
        optionType:
          this.isOption && !this.product.options.length
            ? 'STANDARD'
            : (product.optionType as 'DEFAULT' | 'STANDARD' | 'COMBINATION' | 'MAPPING'),
        deliveryYn: product.deliveryYn as 'Y' | 'N',
        minorPurchaseYn: product.minorPurchaseYn as 'Y' | 'N',
        categoryNo: product.categoryNo,
        mallProductImages: product.mallProductImages,
        commissionInfo: {
          rate: product.commissionInfo.rate,
          type: product.commissionInfo.type as 'PRODUCT' | 'CATEGORY' | 'PARTNER' | 'PURCHASE_PRICE',
        },
        salePeriodInfo: {
          startYmdt: product.salePeriodInfo.startYmdt,
          periodType: product.salePeriodInfo.periodType as 'REGULAR' | 'PERIOD',
          endYmdt: product.salePeriodInfo.endYmdt,
        },
        promotionTextUseYn: product.promotionTextUseYn ? 'Y' : 'N',
        brandName: product.brandName,
        certificationInfo: {
          data: product.certificationInfo.data,
          type: product.certificationInfo.type as 'TARGET' | 'NOT_TARGET' | 'DETAIL_PAGE',
        },
        accumulationUseYn: product.accumulationUseYn as 'Y' | 'N',
        refundableInfo: product.refundableInfo,
        refundableYn: product.refundableYn,
        comparingPriceSiteInfo: {
          check: product.comparingPriceSiteInfo.check as 'NONE' | 'ANY' | 'ALL',
          info: product.comparingPriceSiteInfo.info,
        },
        immediateDiscountInfo: {
          unitType: product.immediateDiscountInfo.unitType as 'AMOUNT' | 'PERCENT',
          amount: product.immediateDiscountInfo.amount,
          periodYn: product.immediateDiscountInfo.periodYn ? 'Y' : 'N',
        },
        platformDisplayInfo: {
          displayYn: product.platformDisplayInfo.displayYn,
          pcYn: product.platformDisplayInfo.pcYn ? 'Y' : 'N',
          mobileWebYn: product.platformDisplayInfo.mobileWebYn ? 'Y' : 'N',
          mobileYn: product.platformDisplayInfo.mobileYn ? 'Y' : 'N',
        },
        cartInfo: {
          useYn: product.cartInfo.useYn as 'Y' | 'N',
          offPeriodYn: product.cartInfo.offPeriodYn ? 'Y' : 'N',
        },
        classType: product.classType as 'DEFAULT',
        displayCategoryNos: product.displayCategoryNos,
        searchengineDisplayYn: product.searchengineDisplayYn ? 'Y' : 'N',
        groupType: product.groupType as 'DELIVERY' | 'SERVICE',
        productStockCnt: product.productStockCnt,
        nonmemberPurchaseYn: product.nonmemberPurchaseYn ? 'N' : 'Y',
        saleMethodType: product.saleMethodType as 'CONSIGNMENT',
        partnerNo: product.partnerNo,
        customPropertyValues: product.customPropertyValues,
        tempSave: isSave ? true : false,
        adminNo: product.adminNo,
        salePrice: product.salePrice,
        urlDirectDisplayYn: product.urlDirectDisplayYn ? 'Y' : 'N',
        promotionInfo: {
          couponYn: product.promotionInfo.couponYn ? 'Y' : 'N',
          promotionYn: product.promotionInfo.promotionYn as 'Y' | 'N',
          additionalDiscountYn: product.promotionInfo.additionalDiscountYn ? 'Y' : 'N',
          freeGiftYn: product.promotionInfo.freeGiftYn,
        },
        mallProductListImage: product.mallProductListImage,
        valueAddedTaxType: product.valueAddedTaxType as 'DUTY' | 'DUTYFREE' | 'SMALL',
        placeOriginInfo: {
          placeOriginsYn: product.placeOriginInfo.placeOriginsYn ? 'Y' : 'N',
          placeOrigin: product.placeOriginInfo.placeOrigin ? product.placeOriginInfo.placeOrigin : undefined,
          placeOriginSeq: product.placeOriginInfo.placeOriginSeq,
        },
        mallNo: product.mallNo,
        useRestockNotiYn: product.useRestockNotiYn,
        // ImagesInformation.vue에서
        // this.liquorDutyTemplateType이 default 일 경우에만 productGuide 값을 api에서 가져오도록 되어 있다.
        productGuides: this.standardCategory?.originType === 'LIQUOR' && this.productGuide ? [this.productGuide] : null,
        relatedProductInfo: product.relatedProductInfo,
        memberGradeDisplayInfo: product.memberGradeDisplayInfo,
        memberGroupDisplayInfo: product.memberGroupDisplayInfo,
      },
    };

    if (product.keywords) {
      param.data.keywords = product.keywords.split(',');
    }
    if (product.promotionTextUseYn) {
      if (product.promotionTextInfo.periodYn) {
        param.data.promotionTextInfo = {
          periodYn: 'Y',
          text: product.promotionTextInfo.text,
          startYmd: product.promotionTextInfo.startYmd,
          endYmd: product.promotionTextInfo.endYmd,
        };
      } else {
        param.data.promotionTextInfo = {
          periodYn: 'N',
          text: product.promotionTextInfo.text,
        };
      }
    }

    if (this.contentUse.contentHeaderUse === 'Y') {
      param.data.contentHeader = this.product.contentHeader;
    }
    if (product.purchasePrice) {
      param.data.purchasePrice = product.purchasePrice;
    }
    if (this.buyInfo.maxBuyYn === 'Y') {
      if (this.buyInfo.maxPurchaseType === 'PERSON') {
        param.data.maxBuyCountInfo = {
          maxBuyPersonCnt: product.maxBuyCountInfo.maxBuyPersonCnt,
        };
      }
      if (this.buyInfo.maxPurchaseType === 'TIME') {
        param.data.maxBuyCountInfo = {
          maxBuyTimeCnt: product.maxBuyCountInfo.maxBuyTimeCnt,
        };
      }
      if (this.buyInfo.maxPurchaseType === 'DAYS') {
        param.data.maxBuyCountInfo = {
          maxBuyDays: product.maxBuyCountInfo.maxBuyDays,
          maxBuyPeriodCnt: product.maxBuyCountInfo.maxBuyPeriodCnt,
        };
      }
    }

    if (product.options.length) {
      if (this.product.optionType !== 'DEFAULT') {
        param.data.options = JSON.parse(JSON.stringify(product.options));
        if (this.product.optionType === 'MAPPING') {
          param.data.options = param.data.options.map(option => {
            const mappings = option.mappings.map(mapping => {
              if (mapping.mappingCount) {
                return {
                  mallOptionNo: mapping.mallOptionNo,
                  salePrice: product.classType === 'EVENT' ? 0 : mapping.salePrice,
                  mappingCount: mapping.mappingCount,
                  mallProductNo: mapping.mallProductNo,
                };
              } else {
                return {
                  mallOptionNo: mapping.itemOptionNo,
                  salePrice: product.classType === 'EVENT' ? 0 : mapping.mappingOptionSalePrice,
                  mappingCount: mapping.mappingCnt,
                  mallProductNo: mapping.itemProductNo,
                };
              }
            });
            // 세트 상품일 경우 판매가는 옵션가격에서의 최저가격으로 설정하기에 등록/수정시 판매가를 덜어야 함
            option.addPrice = option.addPrice - param.data.salePrice;
            option.mappings = mappings;
            return option;
          });
        }
      }
    }
    if (product.customerDemands.length) {
      param.data.customerDemands = product.customerDemands;
    }

    if (product.immediateDiscountInfo.periodYn) {
      param.data.immediateDiscountInfo.startYmdt = product.immediateDiscountInfo.startYmdt;
      param.data.immediateDiscountInfo.endYmdt = product.immediateDiscountInfo.endYmdt;
    }
    if (product.accumulationSaveYn === 'Y') {
      param.data.accumulationRate = product.accumulationRate;
    }
    if (product.cartInfo.useYn && product.cartInfo.offPeriodYn) {
      param.data.cartInfo.offStartYmd = product.cartInfo.offStartYmd;
      param.data.cartInfo.offEndYmd = product.cartInfo.offEndYmd;
    }
    if (product.productManagementCd) {
      param.data.productManagementCd = product.productManagementCd;
    }
    if (this.buyInfo.minBuyYn === 'Y') {
      param.data.minBuyCnt = product.minBuyCnt;
    }
    if (product.dutyInfo) {
      param.data.dutyInfo = {};
      const dutyInfo = product.dutyInfo as any;
      if (dutyInfo.saveTitle) {
        param.data.dutyInfo.saveTitle = dutyInfo.saveTitle;
      }
      if (dutyInfo.dutyContent) {
        const { dutyContent } = dutyInfo;
        param.data.dutyInfo.dutyContent = {
          contents: dutyContent.contents,
          categoryNo: dutyContent.categoryNo,
          categoryName: dutyContent.categoryName,
        };
      }
    }

    if (product.deliveryYn === 'Y') {
      if (product.shippingAreaType) {
        param.data.shippingAreaType = product.shippingAreaType as 'PARTNER_SHIPPING_AREA' | 'MALL_SHIPPING_AREA';
      }
      if (this.deliveryDate.deliveryDateYn === 'Y') {
        param.data.deliveryDueDate = {
          daysOfTheWeek: product.deliveryDueDate.daysOfTheWeek,
        };
        if (this.deliveryDate.periodYn === 'Y') {
          param.data.deliveryDueDate.period = {
            endDate: product.deliveryDueDate.period.endDate,
            startDate: product.deliveryDueDate.period.startDate,
          };
        }
        if (this.deliveryDate.daysAfterPurchaseYn === 'Y') {
          param.data.deliveryDueDate.daysAfterPurchase = product.deliveryDueDate.daysAfterPurchase;
        }
      }
      if (product.deliveryCombinationYn) {
        param.data.deliveryCombinationYn = product.deliveryCombinationYn ? 'N' : 'Y';
      }
      if (product.deliveryInternationalYn) {
        param.data.deliveryInternationalYn = product.deliveryInternationalYn ? 'Y' : 'N';
      }
      if (this.product.shippingAreaType === 'MALL_SHIPPING_AREA') {
        if (product.shippingAreaPartnerNo) {
          param.data.shippingAreaPartnerNo = product.shippingAreaPartnerNo;
        }
      }
      if (product.deliveryTemplateNo && Number(product.deliveryTemplateNo)) {
        param.data.deliveryTemplateNo = Number(product.deliveryTemplateNo);
      }
    }

    param.data.addOptionImageYn = product.addOptionImageYn;

    if (product.addOptionImageYn === 'Y') {
      param.data.content = '';
    } else {
      param.data.content = this.product.content;
    }
    if (product.partnerChargeAmt) {
      param.data.partnerChargeAmt = product.partnerChargeAmt;
    }

    if (product.eanCode) {
      param.data.eanCode = product.eanCode;
    }
    if (product.deliveryCustomerInfo) {
      param.data.deliveryCustomerInfo = product.deliveryCustomerInfo;
    }

    if (product.expirationYmdt) {
      param.data.expirationYmdt = product.expirationYmdt;
    }
    if (this.contentUse.contentFooterUse) {
      param.data.contentFooter = this.product.contentFooter;
    }
    if (product.manufactureYmdt) {
      param.data.manufactureYmdt = product.manufactureYmdt;
    }
    if (product.reservationUseYn === 'Y') {
      param.data.reservationInfoModel = product.reservationInfoModel;
    }
    param.data.stickerNos = product.stickerInfos.map(({ stickerNo }) => stickerNo);
    param.data.stickerInfos = product.stickerInfos;
    if (product.hsCode) {
      param.data.hsCode = product.hsCode;
    }
    param.data.extraManagementCd = product.extraManagementCd;
    if (product.unitPriceYn) {
      param.data.unitPriceInfo = product.unitPriceInfo;
    }
    if (this.productNameEn.checkYn) {
      param.data.productNameEn = product.productNameEn;
    }

    if (product.extraJson) {
      param.data.extraJson = { ...product.extraJson };
    }

    if (product.extraJson.naverPayLimitYn) {
      param.data.extraJson.naverPayLimitYn = 'Y';
    } else {
      param.data.extraJson.naverPayLimitYn = 'N';
    }

    if (product.placeOriginInfo.placeOrigin) {
      param.data.placeOriginInfo.placeOrigin = product.placeOriginInfo.placeOrigin;
    }
    param.data.extraInfo = product.extraInfo;
    if (product.paymentMeansControlYn === 'PAYCO_POINT') {
      param.data.paymentMeansControlYn = 'Y';
      param.data.paymentMeans = ['PAYCO_POINT'];
    } else {
      param.data.paymentMeansControlYn = product.paymentMeansControlYn as 'Y' | 'N';
      param.data.paymentMeans = product.paymentMeans;
    }

    if (this.$route.name === 'EditProduct') {
      param.params = {
        mallProductNo: this.product.mallProductNo,
      };
    }
    if (this.$route.name === 'CopyProduct') {
      if (this.$route.query.syncStockYn === 'Y') {
        param.params = {
          mallProductNo: this.product.mallProductNo,
          copiesReview: this.product.copiesReview,
        };
      }
      param.data.copiesReview = this.product.copiesReview;
      if (param.data.options) {
        param.data.options = param.data.options.map(option => {
          option.mallOptionNo = 0;
          return option;
        });
      }
    }
    return this.$route.name === 'EditProduct' ? (param as PutProductByNoRequest) : (param as PostProductsRequest);
  }
  /**
   * 등록&수정시 에러발생시
   */
  private handleError(err: any) {
    this.setDimmedAreaSwitch(true);
    this.$store.commit('SET_DIMMEDAREA', false);
    if (err.status === 400) {
      // Axios interceptor 에서 에러처리하는 경우
      if (!err.message && !err.result?.message) {
        alert(this.$t('PRODUCT_ADD_ERROR'));
      }

      const { detail } = err.data;

      if (detail) {
        this.convertErrorMessage(detail);
        if (detail.hasOwnProperty('INVALID_MALL_PRODUCT_NO')) {
          alert(detail['INVALID_MALL_PRODUCT_NO']);
        }
        if (detail.hasOwnProperty('INVALID_PARENT_PRODUCT_NO')) {
          alert(detail['INVALID_PARENT_PRODUCT_NO']);
        }
        if (detail.hasOwnProperty('NON_EDITABLE_PRODUCT')) {
          alert(detail['NON_EDITABLE_PRODUCT']);
        }
        if (detail.hasOwnProperty('NON_EDITABLE_MALL_PRODUCT_NO')) {
          alert(detail['NON_EDITABLE_MALL_PRODUCT_NO']);
        }
      }
    }
  }
  viewRejectContent() {
    const mallProductNo = this.$route.params.productNo;
    const params = { mallProductNo };
    this.$api.getInspectionsReject({ params }).then(({ data: { rejectReasons } }: any): void => {
      const popInfo = {
        title: this.pDI18n('PLM_ITEMS_THAT_NEED_TO_BE_MODIFIED_AS_A_RESULT'), //상품심사 결과 수정필요항목
        subStyle: 'width:900px; max-height:800px; scroll-y:auto',
        customBtn: true,
        footBtn: true,
        customBtnEvent: (): void => {
          window.open('/product/edit/' + mallProductNo);
          this.setPopIsShow(false);
        },
        customBtnTxt: this.pDI18n('PLM_PRODUCT_MODIFICATION'), //상품수정
        noticeBox: `<div class="notice_box judgement_reject">
                        <ul>
                          <li>${this.pDI18n('PLM_THIS_ITEM_NEEDS_TO_BE_MODIFIED_FOR')}</li>
                          <li>${this.pDI18n('PLM_PLEASE_CHECKMODIFY_THE_DETAILS_FOR')}</li>
                        </ul>
                      </div>
                      <form>
                        ${this.judgementRejectRenderHTML(rejectReasons)}
                      </form>`,
      };
      this.setPopInfo(popInfo);
      this.setPopIsShow(true);
    });
  }
  viewAgreementRejectxContent() {
    const mallProductNo = this.$route.params.productNo;
    const pathParams = { mallProductNo };
    this.$api.GetSaleAgreementsmallProductNoView({ pathParams }).then(({ data: { reason } }: any): void => {
      const comment = reason ? reason.comment : '';
      const popInfo = {
        title: this.pDI18n('REJECTREASON_POP_TITLE'), //상품심사 결과 수정필요항목
        subStyle: 'width:1050px; max-height:800px; scroll-y:auto',
        customBtn: true,
        footBtn: true,
        customBtnEvent: (): void => {
          window.open('/product/edit/' + mallProductNo);
          this.setPopIsShow(false);
        },
        customBtnTxt: this.pDI18n('PLM_PRODUCT_MODIFICATION'), //판매합의거부 사유
        noticeBox: `<div class="notice_box judgement_reject">
        <ul>
        <li>${this.pDI18n('REJECTREASON_ITEM1')}</li>
        <li>${this.pDI18n('REJECTREASON_ITEM2')}</li>
        </ul>
        </div>
        <div id="rejectSection" class="reject_wrap" style="border-top:0px; margin-top:0px; padding-top:10px;">
        <textarea name="rejectReason" class="count_target" id="rejectReason" cols="30" rows="10" maxlength="300" readonly="">${comment}</textarea>
        <div class="textarea_bottom">
            <span class="count_wrap" for="rejectReason">
                <span class="count counting">${comment.length}</span>/300
            </span>
        </div>
        </div>
          `,
      };
      this.setPopInfo(popInfo);
      this.setPopIsShow(true);
    });
  }
  public rejectReasonInfoObj: { [propName: string]: string } = {
    BASIC_INFO: this.pDI18n('PLD_BASIC_INFORMATION'),
    SALE_INFO: this.pDI18n('PLD_SALES_INFORMATION'),
    IMAGE_INFO: this.pDI18n('PLD_IMAGE_INFORMATION'),
    DELIVERY_INFO: this.pDI18n('PLD_SHIPPING_INFORMATION'),
    ETC_INFO: this.pDI18n('PLD_SEPARATE_APPROVAL_REJECTION_OPINION'),
  };
  public judgementRejectRenderHTML(rejectArray: any): string {
    let judgementRejectHTML = '';
    rejectArray.forEach((reason: any): void => {
      judgementRejectHTML += `<div class="table_tit mt">${this.rejectReasonInfoObj[reason.section]}</div>
      <table class="ncp_tbl grid"><colgroup><col width="170px"><col width=""></colgroup>
      <tbody><tr><th>${this.pDI18n('PLM_ITEM')}</th><th>${this.pDI18n('PLM_REGISTRATION_INFORMATION')}</th></tr>`;
      let subHTML = '';
      reason.items.forEach(({ item, detail: { data, comment } }: any): void => {
        const dataTrim = data.trim();
        const dataText = $($.parseHTML(dataTrim)).text();
        const commentTrim = comment.trim();
        const commentText = $($.parseHTML(commentTrim)).text();

        let contentArea = dataTrim.length ? dataText : commentTrim.length ? commentText : '';
        let commentArea = dataTrim.length && commentTrim.length ? commentText : '';

        subHTML += `<tr><th class="left">${item}</th><td class="left break-all">${contentArea}</td></tr>`;
        if (commentArea.length)
          subHTML += `<tr><td colspan="2" class="break-all"><textarea class="full comment" style="overflow: hidden; resize: none; height: 54px;" readonly="">${commentArea}</textarea></td></tr>`;
      });
      judgementRejectHTML += subHTML;
      judgementRejectHTML += '</tbody></table>';
    });
    return judgementRejectHTML;
  }
  pDI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_PRODUCTLIST_' + needToI18nStr));
  }
  /**
   * error message list -> object
   */
  convertErrorMessage(errorList: any[]) {
    errorList.forEach(err => {
      Vue.set(this.error, err.error, err.message);
    });
  }
  /**
   * 화면에 보여주는 에러메세지 삭제
   */
  deleteError(fields: string | string[]) {
    if (typeof fields === 'object') {
      fields as string[];
      fields.forEach(field => {
        this.$set(this.error, field, null);
        delete this.error[field];
      });
    } else {
      fields as string;
      this.$set(this.error, fields, null);
      delete this.error[fields];
    }
  }
  goListPage() {
    this.$router.push('/product/list');
  }
  beforeDestroy() {
    this.setDimmedAreaSwitch(false);
  }
}
